import type { AssetEvent } from "@/entities/asset-event";
import type { UseListParams } from "@/hooks/queries";
import type { Int } from "@/types";

import { useInfiniteList } from "@/hooks/queries";

import { DEFAULT_ASSET_EVENT_STALE_TIME } from "./constants";

export const useGetAssetEventInfiniteList = (
  assetId: Int,
  params?: UseListParams
) => {
  const { data, ...queryResult } = useInfiniteList<AssetEvent>({
    endpoint: "assets.events",
    rootId: assetId,
    params,
    staleTime: DEFAULT_ASSET_EVENT_STALE_TIME,
  });

  return {
    assetEvents: data ?? [],
    ...queryResult,
  };
};
